<template>
	<div id="leading-enterprises" v-title data-title="中投顾问-高级搜索">
		<headerbar :curindex="searchtype+1"></headerbar> 
		<div class="pagecontent centerpage">  
			<div class="opport-screen-list1" >
				<div class="spage-searchbox ">
					<dl class="opport-screen bdbe">
						<dt class="fl">企业类型</dt>
						<dd class="fl">
						<span :class="searchtype == 1?'a-screen current':'a-screen'" @click="searchtype=1;ajaxsearchcompany()">龙头企业</span><span :class="searchtype == 2?'a-screen current':'a-screen'" @click="searchtype=2;ajaxsearchcompany()">创新企业</span>
						</dd>
					</dl> 
					<div class="header_search header_search_sp">
						<input type="text" class="search_text" v-model="searchtext" placeholder="请输入关键词" @keydown="searchenter">
						<span class="searchbtn" @click="searchkwfun" title="点击搜索"><img src="../../assets/searchicon.png" alt=""></span>
					</div> 
				</div> 
				<dl class="opport-screen bdbe">
					<dt class="fl">省份地区</dt>
					<dd class="fl">
						<span :class="provinceid == 0?'current a-screen':'a-screen'" @click="provincechoose(0,'all');userdata.provinceText='全国地区' ">全国地区</span>
							<span v-for="(item,index) in provincedata" @click="provincechoose(item.areaId,index);userdata.provinceText=item.areaName" :class="item.areaId == provinceid?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
					</dd>
				</dl>
				<dl class="opport-screen bdbe" v-show="citydata.length!=0">
					<dt class="fl">城市地区</dt>
					<dd class="fl">
					<span :class="cityid == 0?'current a-screen':'a-screen'" @click="choosecity(0,'all');userdata.cityText=''">全部</span>
						<span v-for="(item,index) in citydata" @click="choosecity(item.areaId,index);cityid=item.areaId;userdata.cityText=item.name" :data="item.areaId" :class=" item.areaId == cityid ?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
					</dd>
				</dl>
				<dl class="opport-screen bdbe" v-show="countydata.length!=0">
					<dt class="fl">区县地区</dt>
					<dd class="fl">
					<span :class="countyid == 0?'current a-screen':'a-screen'" @click="choosecounty(0);userdata.countyText=''">全部</span>
						<span v-for="(item,index) in countydata" @click="choosecounty(item.areaId);countyid=item.areaId;userdata.countyText=item.name" :data="item.areaId" :class=" item.areaId == countyid ?'a-screen current' : 'a-screen'">{{item.areaName}}</span>
					</dd>
				</dl> 
				<dl class="opport-screen bdbe" v-if="initialTagdata.length!=0">
					<dt class="fl">画像标签</dt>
					<dd class="fl">
					 <div class="selecttag" v-for="(list,index) in initialTagdata"> 
					 	<select :name="list.tagCode" @change="choosetaglist($event,index)">
					 		<option value="empty">{{list.tagName}}</option>
					 		<option :value="item.tagCode" v-for="(item,d) in list.children">{{item.tagName}}</option> 
					 	</select>
						</div> 
						<div class="selecttag" v-for="(list,index) in initialTagdata1" v-show="searchtype==2"> 
							<select :name="list.tagCode" @change="choosetaglist($event,initialTagdata.length+index)">
								<option value="empty">{{list.tagName}}</option>
								<option :value="item.tagCode" v-for="(item,d) in list.children">{{item.tagName}}</option> 
							</select>
						</div>	
					</dd>
				</dl>
				<div class="notionscreen">
					<h5 class="fl">概念分类</h5>
					<div class="oh notiontitle_box fl">
						<div class="fl notionmenu_B">
							<span class="notionmenu" :class="notiontype == notionlist[0].value ?'current':''" @click="notiontype=notionlist[0].value;"  :data="notionlist[0].value">{{notionlist[0].label}}</span>
							<el-cascader v-if="flag" :options="options1" @change="cascaderchange1" @visible-change="cascaderboxtoggle"  :show-all-levels="false" placeholder="" ref="cascaderinput1"  v-model="cascadervalue" :props="{ multiple: true,expandTrigger:'hover',emitPath:false,checkStrictly:false,}"  collapse-tags clearable></el-cascader>
						</div>
						<div class="fl notionmenu_B">
							<span class="notionmenu" :class="notiontype == notionlist[1].value ?'current':''" @click="notiontype=notionlist[1].value;"  :data="notionlist[1].value">{{notionlist[1].label}}</span>
							<el-cascader v-if="flag" :options="options2" @change="cascaderchange2" @visible-change="cascaderboxtoggle"  :show-all-levels="false" placeholder="" ref="cascaderinput2"  v-model="cascadervalue" :props="{ multiple: true,expandTrigger:'hover',emitPath:false,checkStrictly:false,}"  collapse-tags clearable></el-cascader>
						</div>
						<div class="fl notionmenu_B">
							<span class="notionmenu" :class="notiontype == notionlist[2].value ?'current':''" @click="notiontype=notionlist[2].value;"  :data="notionlist[2].value">{{notionlist[2].label}}</span>
							<el-cascader v-if="flag" :options="options3" @change="cascaderchange3" @visible-change="cascaderboxtoggle" :show-all-levels="false" placeholder=""  ref="cascaderinput3"  v-model="cascadervalue" :props="{ multiple: true,expandTrigger:'hover',emitPath:false,checkStrictly:false,}"  collapse-tags clearable></el-cascader>
						</div> 
					</div>
					<div class="fr notionbtn">
						<span class="fl" v-show="notionbtn" @click="notionbtnfun()">确定</span>
						<span class="fl" v-show="notionbtn" >关闭</span>
					</div> 
				</div> 
				<dl class="opport-screen bdte" v-show="usernotionlist.length>0">
					<dt class="fl">已选概念</dt>
					<dd class="fl leftlian oh"> 
						<span class="span-screen" v-for="(item,index) in usernotionlist" @click="deletetag(index)">{{item.name}}</span> 
					</dd>
				</dl>
			</div> 
			<div class="whitebox">
				<div class="enterparise_guide oh" style="width: 95%; ">
					<p class="fl" v-if="!kwtextsearch">产业招商大脑为您找到<span class="searchnum">{{total}}</span>条相关结果</p>
					<p class="fl" style="width: 95%; " v-if="kwtextsearch">产业招商大脑为您找到<span class="searchnum">{{total}}</span>条【 <span class="orangefont">{{kwtextsearchtext}}</span>】相关企业</p>
					<div class="fr timesort" v-show="searchtype == 2">
						<!-- <p :class="orderField == 0 ?'fl current ':'fl '" @click="tablesort(0);" >分数排序<span :class="orderType2 == 1?'timesorticon up':'timesorticon down'"></span></p> -->
						<p :class="orderField == 1 ?'fl current ':'fl '" @click="tablesort(1);">融资时间排序<span :class="orderType1 == 1?'timesorticon up':'timesorticon down'"></span></p>  
					</div>
				</div> 
				<div class="enterprise_list_box" v-show="enterpristlist.length!=0">
					<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="searchtype1 == 1"> 
						<tr><th>企业名称</th><th>所属产业</th><th>画像标签</th><th>地区</th><th>投资数</th><th>员工人数</th></tr> 
						<tr v-for="list in enterpristlist">
							<td class="title"  @click="detailrouterto('/enterprises',list.stockCode,2)" >{{list.title}}</td>
							<td class="conpanytags hastag">
								<span class="span-tag" v-for="item in list.notionlist"  @click="tagrouter('/enterpriseTag',2,'notion',item.id,item.name)">{{item.name}}</span> 
							</td>
							<td class="conpanytags hastag"> 
								<span class="span-tag" v-for="item in list.taglist" @click="tagrouter('/enterpriseTag',2,'tag',item.id,item.name)">{{item.name}}</span> 
							</td>
							<td>{{list.area}}</td>     
							<td v-html="list.invest == 50?'50+':list.invest"></td>  
							<td>{{list.insurePerson}}</td>  
						</tr>
					</table>
					<!-- 创新企业 -->
					<table border="0" cellspacing="0" cellpadding="0" class="enterprise_table" v-if="searchtype1 == 2" >
						<tr>
							<th>企业名称</th>
							<th>所属产业</th>
							<th>画像标签</th> 
							<th>星级</th> 
							<th>融资轮次</th>
							<th>融资时间</th>
							<th>融资金额</th>
							<th>地区</th>
							<th>投资方</th>  
							</tr> 
						<tr v-for="list in enterpristlist">
							<td class="title"  @click="detailrouterto('enterprises',list.stockCode,3)">{{list.title}}</td>
							<td class="conpanytags hastag1" v-show="list.notion!=''">
									<span class="span-tag" v-for="item in list.notionlist"  @click="tagrouter('/enterpriseTag',3,'notion',item.id,item.name)">{{item.name}}</span> 
							</td> 
							<td class="conpanytags" v-show="list.notion==''" style="width: 100px;">
								<div class="" style="color: #999;">-</div>
							</td> 
							<td class="conpanytags hastag1" v-show="list.tag!=''"> 
									<span class="span-tag" v-for="item in list.taglist"  @click="tagrouter('/enterpriseTag',3,'tag',item.id,item.name)">{{item.name}}</span> 
							</td> 
							<td class="conpanytags" v-show="list.tag==''" style="width: 100px;">
								<div class="" style="color: #999;">-</div>
							</td> 
							<td>
								<p class="stargrade" v-if="typeof(list.star) == 'number' && list.star > 0">
									<img src="../../assets/starfull.png" alt="" v-for="item in list.star">
									<img src="../../assets/star.png" alt="" v-for="item in (5-list.star)">
								</p>
								<span v-if="list.star == 0">-</span>
							</td> 
							<td  v-html="list.financingRound.length>0?list.financingRound[0].rount:'-'"></td> 
							<td  v-html="list.financingRound.length>0?list.financingRound[0].time:'-'"></td> 
							<td  v-html="list.financingRound.length>0?list.financingRound[0].amount:'-'"></td>  
							<td>{{list.area}}</td>
							<td class="orglist" >
								<p v-if="list.financingRound.length>0"><span v-for="(org,inds) in list.financingRound[0].orgList" data="org.id" :class="org.id!=0?'curp':''" @click="inorgrouterto(org.id)">
								{{org.orgName}}<i v-if="inds!=list.financingRound[0].orgList.length-1">、</i></span></p>
								<p v-if="list.financingRound.length==0">-</p>
								</td>  
						</tr>
					</table>  
				</div> 
				<div class="centerpage1 company_pagelist" v-show="totalPage>1">
					<zpagenav v-bind:page="page" v-bind:page-size="pageSize" v-bind:total="total" 	v-bind:max-page="maxPage"  v-on:pagehandler="pageHandler">
					</zpagenav>
				</div>
			</div>   
			</div>
		<footerbar></footerbar>
	</div>
</template>

<script>  
// import {PCC} from "../../../assets/js/city.js";
// import $ from "jquery";
	export default {
		name: 'leading-enterprises',
		data() {
			return {
				msg: "产业机会",
			 showscreen:true, 
				notiontype:'',
				searchtype:1,
				searchtype1:1,
				searchtext:"",
				kwtextsearch:false,
				kwtextsearchtext:"",
				notionbtn:false,
				notionlist:[{label: "先进制造业",value:"A"},{label: "传统制造业",value:"B"},{label: "未来产业",value:"C"},{label: "省份城市",value:"D"},],
				notionlist1:{},
				notionlist2:{},
				notionlist3:{},
				notionlist4:{},
				notionlist5:{},
				notionlist6:{}, 
				options:  [],
				options1:{},
				options2:{},
				options3:{},
				flag:false,
				cascadervalue:"",
				usernotionlistsave:[],//用户选择的概念列表存储
				usernotionlist:[],//用户选择的概念列表
				page: 1,  //显示的是哪一页
				haspage:true,//是否还有下一页
				pageSize: 10, //每一页显示的数据条数
				total: 0, //记录总数
				totalPage:1,
				maxPage:10,  //最大页数
				provincelist:[],
				provinceid:0,
				cityid:0, 
				countyid:0,
				provincedata:[],
				citydata:[], 
				countydata:[],
				initialTagdata:[{tagName:"",tagCode:"",children:[]}],
				initialTagdata1:[{tagName:"",tagCode:"",children:[]}],
				searchtagdata:[],
				enterpristlist:[],
				industrydata:[], 
				usertaglist:[],
				capitalid:0,
				typeid1:0,
				typeid2:0,
				typeid3:0,
				typeid4:0,
				typeid5:0,
				typeid6:0, 
				num:0,
				orderField:0,//排序字段 0 分数 1 时间
				orderType:0,//排序方式 0 降序 1 升序
				orderType1:1,//排序方式 0 降序 1 升序
				orderType2:0,//排序方式 0 降序 1 升序
				recapital:[
					{name:"100万以下",id:1251},
					{name:"100-1000万",id:1252},
					{name:"100-5000万",id:1253},
					{name:"5000万及以上",id:1254},
					{name:"自定义",id:1255},  
				],
				moretypedata1:{typename:"企业状态",inputname:"qiyezhuangtai",data:[{name:"aaaaaaaa",id:1351},{name:"bbbbbbbb",id:1352},{name:"cccccccccc",id:1353},{name:"dddddddddd",id:1354},]},  
			}
		},
		beforeCreate() {
			this.bus.$emit('loading', true);
		},
		created() { 
			this.$nextTick(() => {
			        // 禁用右键
			        document.oncontextmenu = new Function("event.returnValue=false");
			        // 禁用选择
			        document.onselectstart = new Function("event.returnValue=false");
			      }); 
		 var _this=this;  
			this.getuserinfor();  
			// _this.notionlist=NotionTree; 
			//三大产业概念数据
			this.$axios.get(this.$api.tag.notion.list()+'?level=5',{headers:{AuthToken:this.userdata.token}}).then(function(res){
				// console.log(res.data)
				if(res.data.success){  
					console.log(res.data.list)
					_this.notionlist=res.data.list;
					_this.options1=res.data.list[0].children;
					_this.options2=res.data.list[1].children;
					_this.options3=res.data.list[2].children;
					_this.flag=true;
					// _this.notionlist=res.data.list;  
				}else{ 
					
				} 
			}).catch(function (error) { 
				// 请求失败处理 console.log(error);
			});
			this.$axios.get(this.$api.cyl.area.get(),{headers:{AuthToken:this.userdata.token}}).then(function(res){
				// console.log(res.data)
				if(res.data.success){  
					console.log(res.data)
				 _this.provincedata=res.data.list; 
				}else{ 
					
				} 
			}).catch(function (error) { 
				// 请求失败处理 console.log(error);
			});
			this.getocnapidoctaglist(2);
		},
		mounted() { 
			var _this = this;
			this.searchtype = this.$route.query.type *1 -1; 
   this.pageHandler(1);   
			$('.notionmenu').click(function(){
				// console.log(51411);
				// console.log($(this).siblings('.el-cascader').html())
				$(this).siblings('.el-cascader').click(); 
				
			})
			// this.ajaxsearchcompany();
		},
		methods: { 
			cascaderchange(value){  
				const checkedNodes = this.$refs['cascaderinput'].getCheckedNodes()
				console.log(checkedNodes) // 获取当前点击的节点
				var ddddg=[];
				for(var i=0;i<checkedNodes.length;i++){
					 ddddg.push({name:checkedNodes[i].label,id:checkedNodes[i].value})
				};
				this.usernotionlist=ddddg;
				// console.log(value); 
			}, 
			//当级联面板打开/关闭时
			cascaderboxtoggle(bool){
				// if(!bool){
				// 	this.notiontype=0;
				// }
				this.notionbtn=bool;
			},
			//当获取到值时
			cascaderchangesm(checkedns){
				var ddda=[],dddb=[],dddc=[],allddd=[];
				var dddaa=[],dddaa1=[],dddbb=[],dddbb1=[],dddcc=[],dddcc1=[],dddee=[],dddee1=[],alld=[];
				var ddtds='';
					for(var i=0;i<checkedns.length;i++){
						if(checkedns[i].level == 1){ 
							dddaa.push(checkedns[i].value);
							dddaa1.push(checkedns[i].value);
						}else if(checkedns[i].level == 2){ 
							dddbb.push(checkedns[i].value); 
							dddbb1.push(checkedns[i].value); 
						}else if(checkedns[i].level == 3){ 
							dddcc.push(checkedns[i].value); 
							dddcc1.push(checkedns[i].value); 
						}else if(checkedns[i].level == 4){ 
							dddee.push(checkedns[i].value); 
						}
						allddd.push({name:checkedns[i].label,id:checkedns[i].value});
					};  
					for (var i=0;i<dddbb.length;i++){
						let bstring=dddbb[i];
						for(var d=0;d<dddaa.length;d++){
							let astring=dddaa[d];
							if(bstring.indexOf(astring) > -1 ){
								 dddbb[i]='xs';
							} 
						} 
					};    
					for (var i=0;i<dddcc.length;i++){
						let bstring=dddcc[i];  
							for(var d=0;d<dddbb1.length;d++){
								let astring=dddbb1[d];
								if(bstring.indexOf(astring) > -1 ){
									dddcc[i]="xs";
								} 
							} 
					}; 
					for (var i=0;i<dddee.length;i++){
						let bstring=dddee[i];  
							for(var d=0;d<dddcc1.length;d++){
								let astring=dddcc1[d];
								if(bstring.indexOf(astring) > -1 ){
									dddee[i]="xs";
								} 
							} 
					};   	 
					for (var i=0;i<dddbb.length;i++){
						let bstring=dddbb[i];  
						if(bstring!="xs"){
							dddaa.push(bstring);
						} 
					};
					for (var i=0;i<dddcc.length;i++){
						let bstring=dddcc[i];  
						if(bstring!="xs"){
							dddaa.push(bstring);
						}
					}; 
					for (var i=0;i<dddee.length;i++){
						let bstring=dddee[i];  
						if(bstring!="xs"){
							dddaa.push(bstring);
						} 
					};
					// console.log(dddaa,dddbb,dddcc,dddee);  
						var usernotionlistd=[];
					for(var a=0;a<dddaa.length;a++){
						let astring=dddaa[a];
						for(var b=0;b<allddd.length;b++){
							if(astring == allddd[b].id){
								usernotionlistd.push(allddd[b]);
							}
						}
					} 
					this.usernotionlistsave=usernotionlistd; 
			},
			cascaderchange1(value){ 
				const checkedNodes = this.$refs['cascaderinput1'].getCheckedNodes() 
				this.cascaderchangesm(checkedNodes);
			}, 
			cascaderchange2(value){
				const checkedNodes = this.$refs['cascaderinput2'].getCheckedNodes() 
				this.cascaderchangesm(checkedNodes);
			}, 
			cascaderchange3(value){
				const checkedNodes = this.$refs['cascaderinput3'].getCheckedNodes() 
				this.cascaderchangesm(checkedNodes);
			}, 
			//时间/分数升降序
			tablesort(field){
				this.orderField = field;
				if(field == 1){
					this.orderType1 = Math.abs(this.orderType1 -1);this.orderType=this.orderType1; 
				}else{
					this.orderType2 = Math.abs(this.orderType2 -1);this.orderType=this.orderType2;
				};
					this.ajaxsearchcompany();
			},
			//搜索关键词
			searchkwfun(){ 
				this.searchtext=$.trim(this.searchtext); 
				// if(this.searchtext!="" || ){
				this.ajaxsearchcompany();
				// } 
			},
			searchenter(e){ 
				if(e.keyCode == 13){
					this.searchkwfun();
				}
			},
			//画像标签高级搜索
			//获取后台标签列表
			getocnapidoctaglist(type){ 
				var _this=this; 
				this.$axios.get(this.$api.tag.tag.list()+'?categoryId='+type,{headers:{AuthToken:this.userdata.token}}).then(function(res){   
					// console.log('gettagno',res.data); 
				 var tagdsta=res.data.list.filter(data=>{
						return data.children.length>0;    
					})
					for(var i=0;i<tagdsta.length;i++){
						_this.searchtagdata.push('empty');
					}
					if(type == 2){
						_this.initialTagdata=tagdsta; 
						_this.getocnapidoctaglist(3); 
					}else if(type == 3){
						_this.initialTagdata1=tagdsta; 
					} 
					// console.log(tagdsta,_this.searchtagdata);
				}); 
			},  
			//选择标签
			choosetaglist(obj,index){ 
				console.log(obj.target.value,index);
				this.searchtagdata[index]=obj.target.value;
			 this.ajaxsearchcompany(); 
			},
			//获取用户信息
			getuserinfor(){
				let dataddd=sessionStorage.getItem('userData') ? sessionStorage.getItem('userData'):localStorage.getItem('userData') ;
				if(typeof(dataddd) == 'object'){
				this.userdata = dataddd;
				}else{
				this.userdata = JSON.parse(dataddd);
				}  
				// console.log(this.userdata.tagText,this.userdata.tag);
			// this.usertaglist=this.taglistfun(this.userdata.tagText,this.userdata.tag);
			// this.usernotionlistsave=this.taglistfun(this.userdata.notionText,this.userdata.notion);
			}, 
			detailrouterto(path,id,type){
				let routeUrl = this.$router.resolve({
						path: path,query: {type:type,id:id}
				});
				window.open(routeUrl.href, '_blank');  
			}, 
			pageHandler: function (page) { 
				this.page = page; 
				this.ajaxsearchcompany(page); 
			},
			//省份城市选择
			 provincechoose(id,i){ 
					this.provinceid =id;this.cityid =0; this.countyid =0;
					this.countydata=[];
					if(i!="all" && this.provincedata[i].children != null){
							this.citydata=this.provincedata[i].children;
					}else{
						this.citydata=[];
					} 
					this.page=1; 
					this.ajaxsearchcompany();
				},
				choosecity(id,i){
					//	console.log('choosecity',id);
					this.cityid =id;this.countyid =0;
					if(i!="all" && this.citydata[i].children!= null){
							this.countydata=this.citydata[i].children;
					}else{
						this.countydata=[];
					} 
					this.page=1; 
					this.ajaxsearchcompany(); 
				}, 
				choosecounty(id){
					//	console.log('choosecity',id);
					this.countyid =id;
					this.page=1; 
					this.ajaxsearchcompany();
				}, 
				//删除标签
				deletetag(ind){
					this.usertaglist=this.usertaglist.filter(function(item,index){
						return index!=ind;
					});
					this.page=1;
					this.ajaxsearchcompany(); 
					if(this.usertaglist.length == 0){
						this.showscreen=true;
					}
				}, 
				notionbtnfun(){ 
					this.usernotionlist=this.usernotionlistsave; 
					// this.searchtext="";
					this.ajaxsearchcompany();  
				},
				//字符串拼接
				jsondouhao(name,data){
					var notionja="",douhao='%2C'; 
					if(data.length>0){ 
						if(name == "kw"){
								notionja=data;
						}else{
							for(var i=0;i<data.length;i++){
								if(i==data.length-1){
									douhao='';
								}
								if(name == 'tag'){
									notionja+=data[i]+douhao;
								}else if(name == "notion"){
									notionja+=data[i].id+douhao;
								}  
							}
						} 
						notionja='&'+name+'='+notionja; 
					}  
					return notionja;
				}, 
				ajaxsearchcompany(pages){ 
				this.bus.$emit('loading',true); 
				var ajpage=1;
				if(pages){
					ajpage=pages;
				}
				this.page=ajpage;
				var _this=this;
					//公司列表 type:1/2 area:provinceid industry行业id capital 注册资本 （暂无） 标签（暂无） chain相关产业链（暂无） page页码
				 var searchtagdata1=this.searchtagdata.filter(item=>{return item!='empty'});
					// console.log(searchtagdata1);
					var tagaja=_this.jsondouhao('tag',searchtagdata1);   
					var	notionja=_this.jsondouhao('notion',this.usernotionlistsave);  
					var	kwaja=_this.jsondouhao('kw',this.searchtext);  
					if(this.userdata.token == _this.testtoken){
						notionja="";
					} 
					// console.log('省份城市ID',this.provinceid,this.cityid); 
					var ajaxurl=this.$api.cyl.enterprise.list()+'?type='+this.searchtype+'&search=1&city='+this.cityid+'&province='+this.provinceid+'&county='+this.countyid+notionja+tagaja+kwaja+'&page='+ajpage;
					if(_this.searchtype == 2){
						ajaxurl+="&orderField="+this.orderField+"&orderType="+this.orderType;
					}
					// if(this.searchtext!=''){
					// 	ajaxurl=this.$api.cyl.enterprise.list()+'?type='+this.searchtype+'&city='+this.cityid+'&province='+this.provinceid+'&kw='+this.searchtext+'&page='+ajpage;
					// }
					console.log(ajaxurl)
					this.$axios.get(ajaxurl,{headers:{AuthToken:this.userdata.token}}).then(function(res){
						// console.log(res.data) 
						if(res.data.success){  
						_this.enterpristlist=res.data.list; 
							if(_this.searchtype == 1 || _this.searchtype == 2){
								//大小企业 
							}else if(_this.searchtype == 5){
								//机构列表 
							} 
							for(var i=0;i<res.data.list.length;i++){
								_this.enterpristlist[i].notionlist=_this.taglistfun(_this.enterpristlist[i].notion,_this.enterpristlist[i].notionCode);  
								_this.enterpristlist[i].taglist=_this.taglistfun(_this.enterpristlist[i].tag,_this.enterpristlist[i].tagCode); 
									//创新企业专属
								if(_this.searchtype==2  && _this.enterpristlist[i].financingRound == null){
									_this.enterpristlist[i].financingRound=[];
								}
							} 
							_this.bus.$emit('loading',false); 
							_this.totalPage=res.data.totalPage;
							_this.pageSize=res.data.pageSize;  
							_this.total=res.data.totalRecord; 
							_this.haspage=res.data.list.length  == res.data.pageSize; 
							_this.searchtype1=_this.searchtype;  
							_this.kwtextsearch=_this.searchtext!=""; 
							_this.kwtextsearchtext=_this.searchtext;
						}else{ 
							
						} 
					}).catch(function (error) {}); 
				// console.log(datas);  
			}
		}
	}
</script>

<style type="text/css" scoped="scoped">
	@import "../../assets/css/zpageNav.css";
</style>
<style>
</style>
